import { AssetType, EnabledTool } from 'types/project';
import { addConfigurationRent } from './addConfigurationRent';

interface Props {
  assetType: AssetType;
  spaceConfigurator?: EnabledTool;
  coliving?: EnabledTool;
}

export const redirectToConfigurator = ({ assetType, spaceConfigurator, coliving }: Props) => {
  if (assetType === 'apartment' && spaceConfigurator?.enabled) {
    addConfigurationRent(spaceConfigurator);
  } else if (assetType === 'room' && coliving?.enabled) {
    window.open(coliving.url, '_blank');
  }
};
